export default "__VITE_ASSET__DAg5v1QY__"